import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http, CATEGORIES } from "../lib/api";
import HeadlineList from "../components/HeadlineList";

export default function Category() {
  const { slug } = useParams();
  const meta = CATEGORIES.find((c) => c.slug === slug);
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      // Use round-robin diversity (max 4 per paper) so a single high-volume outlet
      // doesn't dominate the section. Estados/Congresos de los Estados keep regional
      // coverage; the rest are national-only.
      const isRegional = slug === "estados" || slug === "congresos-estados";
      const isCongreso = slug === "congreso";
      const { data } = await http.get("/articles", {
        params: {
          category: slug,
          limit: 80,
          diverse: true,
          max_per_source: 4,
          national_only: !isRegional,
          // Congreso mixes editorial coverage with official boletines (Diputados, etc.)
          include_institutional: isCongreso,
        },
      });
      setItems(data);
    })();
  }, [slug]);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-12 py-10 animate-fade-in" data-testid={`category-page-${slug}`}>
      <p className="section-eyebrow">SECCIÓN</p>
      <h1 className="font-serif-display text-5xl sm:text-6xl text-ink leading-none mt-2 mb-2">
        {meta?.label || "Categoría"}
      </h1>
      <p className="text-sub text-sm font-sans">
        Selección curada de las notas más relevantes en {meta?.label?.toLowerCase()}.
      </p>
      <div className="dbl-rule mt-6 pt-2">
        <HeadlineList items={items} testId="category-headlines" />
      </div>
    </div>
  );
}
